import script from "./OtpCell.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpCell.vue?vue&type=script&setup=true&lang=js"

import "./OtpCell.vue?vue&type=style&index=0&id=fd190070&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd190070"]])

export default __exports__